export const environment = {
  production: true,
  isHideManyComponent: true,
  timeoffset: (new Date().getTimezoneOffset() / -60) * 60 * 60 * 1000, // UTC+7
  // apiUrl: 'http://localhost:5000/components',
  apiUrl: 'https://api.aqbakery.com',
  roles: [
    'manager', // Quản lý
    'manufacture', // Sản xuất
    'warehouse', // Kho
    'accountant', // Kế toán
    'admin', // Quản trị viên
    'superadmin', // Quản trị viên cấp cao
    'supervisor', // Giám sát
    'hr', // Nhân sự
    'sales', // Bán hàng
    'marketing', // Tiếp thị
    'support', // Hỗ trợ
    'developer', // Phát triển
    'designer', // Thiết kế
    'analyst', // Phân tích
    'consultant', // Tư vấn
    'auditor', // Kiểm toán
    'intern', // Thực tập sinh

  ],
  pageSize: [25, 50, 100, 200, 500],
  callRecordType: [
    { name: 'in', value: 1 },
    { name: 'out', value: 2 },
    { name: 'missed', value: 3 },
    { name: 'voicemail', value: 4 },

  ],
  timesheetDays: [
    { name: 'monday', day: 2, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'tuesday', day: 3, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'wednesday', day: 4, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'thursday', day: 5, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'friday', day: 6, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'saturday', day: 7, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'sunday', day: 8, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 }
  ],
  timekeepingTypes: [
    { value: 1, name: 'timekeeping_hour' },
    { value: 2, name: 'timekeeping_day' },
    { value: 3, name: 'timekeeping_kpi' },
    { value: 4, name: 'timekeeping_none' },
    { value: 5, name: 'timekeeping_type_hour_kpi' },
    { value: 6, name: 'timekeeping_type_day_kpi' },
  ],

  constants: {
    MAX_FILE_SIZE: 10 * 1024 * 1024,
    MEDIA_PUBLIC_TIME: 30 * 1000,
    LOCALSHIPPING: {
      STATUS: {
        PENDING: 1,
        DRIVER_CONFIRM: 2,
        PICKUP: 3,
        DELIVERING: 4,
        DELAYED: 5,
        DELIVERED: 6,
        CANCELLED: 7,
        RETURNED: 8,
      }
    },
    GROUP_STATUS: {
      ACTIVE: 1,
      INACTIVE: 2,
      PENDING: 3
    },
    POSITION_STATUS: {
      ACTIVE: 1,
      INACTIVE: 2,
      PENDING: 3
    },
    MEDIA_TYPE: {
      IMAGE: 1,
      VIDEO: 2,
      AUDIO: 3,
      DOCUMENT: 4,
      ARCHIVE: 5
    },
    WORK_CALENDAR: {
      ACTIVE: 1,
      INACTIVE: 2,
      PENDING: 3
    },
    TIMEKEEPING: {
      HOUR: 1,
      DAY: 2,
      KPI: 3,
      NONE: 4,
      HOUR_KPI: 5,
      DAY_KPI: 6,
    },
    ATTENDANCE: {
      CHECKIN: 1,
      CHECKOUT: 2,
    },
    OVERTIME: {
      STATUS: {
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3,
      },
      TYPE: {
        FREE: 1,
        CONTROL: 2,
      },
    },
    LEAVE_REQUEST: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
    },
    ABSENCE_REQUEST: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
    },
    RELOCATION: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
    },
    SALARY: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
    },
    SALARY_KPI: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
    },
    KPI_UNIT: {
      ACTIVE: 1,
      INACTIVE: 2,
      PENDING: 3
    },
    SALARY_ALLOWANCE: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
    },
    SALARY_ADVANCE: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
      PAID: 4,
    },
    SALARY_COMPONENT: {
      TYPE: {
        CONTINUOUS: 1,
        MONTHLY: 2,
      }
    },
    ALLOWANCE_EXTRA: {
      PLUS: 1,
      MINUS: 2,
    },
    PAYSILP: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
      PAID: 4,
    },
    WAREHOUSE: {
      ACTIVE: 1,
      INACTIVE: 2,
    },
    MATERIAL: {
      ACTIVE: 1,
      INACTIVE: 2,
    },
    SUPPLIER: {
      ACTIVE: 1,
      INACTIVE: 2,
    },
    STORE: {
      ACTIVE: 1,
      INACTIVE: 2,
    },
    PHONE_CONTACT: {
      ACTIVE: 1,
      INACTIVE: 2,
    },
    PHONE_NUMBER: {
      ACTIVE: 1,
      INACTIVE: 2,
    },
    CALL_TYPE: {
      UNKNOWN: 0,
      INCOMING: 1,
      OUTGOING: 2,
      MISSED: 3,
      VOICEMAIL: 4,
      REJECTED: 5,
      BLOCKED: 6,
      ANSWERED_EXTERNALLY: 7
    },
    TASK: {
      TYPE: {
        SCHEDULED: 1,
        IN_PROGRESS: 2,
        COMPLETED: 3,
        CANCELLED: 4,
        PAUSED: 5
      },
      PRIORITY: {
        LOW: 1,
        MEDIUM: 2,
        HIGH: 3
      }
    },
    TIMEKEEPING_REVIEW: {
      PENDING: 1,
      APPROVED: 2,
      REJECTED: 3,
    },
    DEPOSIT_INTEREST: {
      UNPAID: 1,
      PAID: 2,
      REFUNDED: 3,
    },
    PRODUCT_REQUEST_STATUS: {
      PENDING: 1,
      PROCESSING: 2,
      COMPLETED: 3,
      REJECTED: 4,
      CANCELED: 5
    }
  }
};
